import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import QueryBuilder from './QueryBuilder';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';

import Chip from '@mui/material/Chip';
import {LibraryAddRounded, AutorenewRounded} from "@mui/icons-material";
import { Row, Tabs, Segmented, Layout, Divider, Modal, Space } from 'antd';
import { fetchFilteredTickers } from "../../api/tickersApi";
import { MongoQueryBuilder } from "../../utils/mongoQuery";
import TickerTable from './TickerTable';
import {screenerMetrics} from "./screensConfig";
import PageHeader from "../../components/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";
import {HorizontalRuleRounded, ChevronRightRounded, ChevronLeftRounded} from "@mui/icons-material";
import {getScreenTypeColor, BASE_PROJECTION_FIELDS} from "./screensConfig";
import AppDataForm from "../../SuperComponents/AppData/AppDataForm";
import {selectAppDataById, selectAppDataByType} from "../../store/slices/user.slice";
import AppDataCollection from "../../components/AppDataCollection";
const { TabPane } = Tabs;



const buildMongoQuery = ({securityType, filters, limit=100})=>{
    const queryBuilder = new MongoQueryBuilder();
    // Add the type condition
    queryBuilder.addCondition({ fullPath: 'type', operator: '=', value: securityType });
    // Add common projection and sorts for all queries
    queryBuilder.updateProjection([...BASE_PROJECTION_FIELDS]);
    queryBuilder.setSort({"metrics.mktcap": -1});
    if (Object.keys(filters).length > 0){
        for (let k in filters){
            const metricObject = screenerMetrics[k];
            const mult = metricObject.type === 'percentage' ? 0.01: 1;
            let innerQuery = null;
            if (Array.isArray(filters[k].value)){
                innerQuery = {
                    $gt: filters[k].value[0] * mult ,
                    $lt: filters[k].value[1] * mult,
                }
            }
            else {
                innerQuery = {
                    [filters[k].op==='greater'? '$gt': '$lt']: filters[k].value * mult
                }
            }
            queryBuilder.customConditions.push({[`metrics.${k}`]: innerQuery});
            queryBuilder.customConditions.push({
                exchange: {$nin: ['pink', '', 'otcqb', 'otcbb', 'otcqx', 'otcgrey', 'otcce', 'otcmkts']},
            })
        }
    }
    queryBuilder.setLimit(limit);
    return queryBuilder
}


const FilterTag = ({filter, handleRemoveFilter})=>{
    let Icon = HorizontalRuleRounded;
    if (filter.condition!=='range'){
        Icon = filter.condition==='greater'? ChevronRightRounded: ChevronLeftRounded;
    }
    return (
        <Chip
            sx={{background: getScreenTypeColor(filter.name), color: '#FFF'}}
            icon={<Icon style={{color: "#FFF"}}  />}
            label={`${filter.name} ${filter.value}`}
            onDelete={()=>handleRemoveFilter(filter.name)}
        />
    )

}

const ActiveFilters = ({filters, handleRemoveFilter})=>{
    if (!filters) return null;
    return (
        <>
            {Object.entries(filters).length > 0 && (
                <Row className={'mt-3'} style={{background: "#ECEFF0", borderRadius: '8px', padding: '10px 20px'}} wrap>
                    {Object.entries(filters).map(([k, v])=>(
                        <div className={'p-2'}>
                            <FilterTag key={k} filter={{name: k, condition: v.condition, value: v.value}} handleRemoveFilter={handleRemoveFilter} />
                        </div>
                    ))}
                </Row>
            )}

        </>
    )
}


const SecurityTypeSegment = ({ onChange }) => {
  const [selectedValue, setSelectedValue] = React.useState('stock'); // Default to 'stock'

  const handleChange = (event, newValue) => {
    setSelectedValue(newValue);
    onChange(newValue); // Call the provided onChange handler
  };

  return (
    <ButtonGroup variant="outlined" aria-label="security type selection" value={selectedValue} onChange={handleChange}>
      <Button value="stock" variant={'contained'}>Stocks</Button>
      <Button value="etf">ETFs</Button>
    </ButtonGroup>
  );
};


const Screens = () => {
  const [filters, setFilters] = useState({});
  const [activeKey, setActiveKey] = useState('stock');
  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showSelectModal, setShowSelectModal] = useState(false);
  const dispatch = useDispatch();
  const savedScreeners = useSelector((state)=>selectAppDataByType(state, 'screener'));
  const selectedScreenerId = useSelector((state)=>state.appStates.selectedAppdataIds.screen);
  const selectedScreener = useSelector((state)=>selectAppDataById(state, selectedScreenerId));

  const allFilteredTickers = useSelector(state => state.tickers.filteredTickers);
  console.log('savedScreeners', savedScreeners);
  console.log('selectedScreener', selectedScreener)


  const getMongoQuery=()=>{
      const mongoQuery = buildMongoQuery({securityType: activeKey, filters});
      return mongoQuery.toMongoQuery()
  }

  const executeQuery = ()=>{
      dispatch(fetchFilteredTickers(getMongoQuery(), activeKey));
  }

  const formatPayload = ()=>{
      const query = getMongoQuery();
      return {
          filters: filters,
          query: JSON.stringify(query),
      }
  }


  useEffect(() => {
      executeQuery();
  }, [dispatch, activeKey]);


  const handleFilter = (filterName, op, value, enabled) => {
      if (enabled){
          setFilters(prev => {
              return {...prev, [filterName]: {op, value}}
          });
      }
      else {
          let newFilters = {...filters};
          delete newFilters[filterName];
          setFilters(newFilters);
      }
  };

  const onRemoveFilter = (filterName)=>{
      handleFilter(filterName, null, null, false);
  }



  return (
      <>
        <PageHeader title={'Screens'}
                    logoUrl={iconMapping.screener}
                    actions={[
                        <SecurityTypeSegment onChange={(v)=>setActiveKey(v)} />,

                        <Button startIcon={<AutorenewRounded/>} variant={'outlined'} color={'primary'} onClick={executeQuery}>SUBMIT</Button>,
                        <Button onClick={()=>setShowSaveModal(true)} startIcon={<LibraryAddRounded/>} variant={'text'}>Save to Screens</Button>,
                    ]}
        />

        <Layout className={'px-5 py-3'}>
            <Layout.Sider
              width={350}
              style={{background: "#fff", borderRight: '1px solid #ddd'}}
            >
                <QueryBuilder metrics={screenerMetrics} onAddFilter={handleFilter} />
            </Layout.Sider>
            <Layout.Content style={{padding: '2.5%'}}>
              <ActiveFilters handleSave={()=>setShowSaveModal(true)}
                             filters={filters}
                             handleRemoveFilter={onRemoveFilter}
              />
                {Array.isArray(allFilteredTickers) && allFilteredTickers.length > 0 && <TickerTable tickers={allFilteredTickers} />}
            </Layout.Content>
            {showSaveModal && (
                <AppDataForm appId={selectedScreenerId}
                             appType={'screener'}
                             initialData={formatPayload()}
                             initialTitle={'My New Screen'}
                             open={showSaveModal}
                             onClose={() => setShowSaveModal(false)}
                />
            )}

        </Layout>
      </>
  );
};

export default Screens;
